import type { MaintenanceWorkOrderListItem } from '@gb-ticket/shared-types';

import { PersonChip } from '@/platform/components/person-chip';

import { formatMaintenanceListDate } from '@/products/maintenance/features/maintenance-list-query';
import type { MaintenanceRecordColumn } from '@/products/maintenance/features/maintenance-record-list';

export function maintenanceWorkOrderScheduledColumn(): MaintenanceRecordColumn<MaintenanceWorkOrderListItem> {
  return {
    id: 'scheduled',
    header: 'Termin',
    sortKey: 'scheduledFor',
    cell: (order) => formatMaintenanceListDate(order.scheduledFor),
  };
}

export function maintenanceWorkOrderDueColumn(): MaintenanceRecordColumn<MaintenanceWorkOrderListItem> {
  return {
    id: 'due',
    header: 'Fälligkeit',
    sortKey: 'dueAt',
    cell: (order) => formatMaintenanceListDate(order.dueAt),
  };
}

export function maintenanceWorkOrderCustomerColumn(): MaintenanceRecordColumn<MaintenanceWorkOrderListItem> {
  return {
    id: 'customer',
    header: 'Kunde',
    sortKey: 'customerName',
    cell: (order) => order.customer.name,
  };
}

export function maintenanceWorkOrderInstallationColumn(): MaintenanceRecordColumn<MaintenanceWorkOrderListItem> {
  return {
    id: 'installation',
    header: 'Anlage',
    sortKey: 'installationName',
    cell: (order) => order.installation.name,
  };
}

export function maintenanceWorkOrderTechnicianColumn(): MaintenanceRecordColumn<MaintenanceWorkOrderListItem> {
  return {
    id: 'tech',
    header: 'Monteur',
    sortKey: 'assignedToName',
    cell: (order) => (
      <PersonChip
        displayName={order.assignedTo.displayName}
        profilePhotoUrl={order.assignedTo.profilePhotoUrl}
      />
    ),
  };
}
